<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="md:col-6 col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="project.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Надзадача</label>
            <crm-auto-complete
              [(value)]="project.parent"
              [suggestions]="projects"
              (completeMethod)="projectSearch($event.query)"
              (valueChange)="changeParentProject()"
              field="name"
              [isError]="$any(errors?.parent)"
              appendTo="body"></crm-auto-complete>
            <small
              *ngIf="errors?.parent"
              class="p-error">
              {{ errors.parent | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="project.client"
              [isError]="$any(errors?.client)"
              [showClear]="true"
              [customSearch]="false"
              appendTo="body"></crm-client-auto-complete>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Приоритет</label>
            <crm-priority-single-select
              [(selectedPriority)]="project.priority"
              [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-priority-single-select>
            <small
              *ngIf="errors?.priority"
              class="p-error">
              {{ errors.priority | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Суть</label>
            <crm-editor
              [(value)]="project.description"
              height="250px"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дедлайн</label>
            <crm-datepicker
              [(value)]="project.deadline"
              [disabled]="(form$ | async)?.isShowDelete && !isCreator"
              [showTime]="true"
              [stepMinute]="15"
              [class]="errors?.deadline ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.deadline"
              class="p-error">
              {{ errors.deadline | join }}
            </small>
          </div>
        </div>

        <div
          *ngIf="!(form$ | async)?.isShowDelete"
          class="field">
          <label class="font-medium">Файлы</label>
          <div
            *ngIf="project.files?.length"
            class="mb-2">
            <crm-files-list
              [files]="project.files"
              [canDelete]="true"
              (deleteFile)="deleteFile(project.files, $event)"></crm-files-list>
          </div>
          <p-fileUpload
            #fileUpload
            mode="basic"
            [customUpload]="true"
            chooseIcon="pi-paperclip"
            chooseLabel="Прикрепить файл"
            [disabled]="uploadingFiles"
            (uploadHandler)="uploadFiles($event)"
            [auto]="true">
          </p-fileUpload>
        </div>
      </p-card>

      <div class="mt-3">
        <p-card header="Дополнительные реквизиты">
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium">Эпик</label>
              <crm-master-milestone-single-select
                [masterMilestones]="masterMilestones"
                [(selectedMasterMilestone)]="project.masterMilestone"
                [isError]="$any(errors?.masterMilestone)"
                [customRequest]="true"
                appendTo="body"></crm-master-milestone-single-select>
              <small
                *ngIf="errors?.masterMilestone"
                class="p-error">
                {{ errors.masterMilestone | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Бюджетная статья</label>
              <crm-direction-single-select
                [directions]="directions"
                [(selectedDirection)]="project.direction"
                [groupsDisabled]="true"
                [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
                appendTo="body">
              </crm-direction-single-select>
              <small
                *ngIf="errors?.direction"
                class="p-error">
                {{ errors.direction | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Бизнес единица</label>
              <crm-unit-single-select
                [(selectedUnit)]="project.unit"
                [isError]="$any(errors?.unit)"
                [showClear]="true"
                appendTo="body"></crm-unit-single-select>
              <small
                *ngIf="errors?.unit"
                class="p-error">
                {{ errors.unit | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Время план</label>
              <p-inputNumber
                [(ngModel)]="project.plannedMin"
                [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
              <small
                *ngIf="errors?.plannedMin"
                class="p-error">
                {{ errors.plannedMin | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Филиал</label>
              <crm-filial-single-select
                [(selectedFilial)]="project.filial"
                [isError]="$any(errors?.filial)"
                [showClear]="true"
                appendTo="body"></crm-filial-single-select>
              <small
                *ngIf="errors?.filial"
                class="p-error">
                {{ errors.filial | join }}
              </small>
            </div>
          </div>
        </p-card>
      </div>
    </div>

    <div class="md:col-6 col-12">
      <p-card header="Участники">
        <div class="field">
          <label class="font-medium required-field">Ответственный</label>
          <crm-user-single-select
            [users]="users"
            [(selectedUser)]="project.responsible"
            (selectedUserChange)="updateMembers()"
            [customSearch]="true"
            appendTo="body"></crm-user-single-select>
          <p
            *ngIf="errors?.responsible"
            class="p-error">
            {{ errors.responsible | join }}
          </p>
        </div>

        <h3 class="font-medium -mb-2">Аудиторы</h3>
        <p-divider></p-divider>
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [users]="users"
              [(selectedUsers)]="project.userAuditors"
              (selectedUsersChange)="updateMembers()"
              [isError]="$any(errors?.userAuditors)"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            <p
              *ngIf="errors?.userAuditors"
              class="p-error">
              {{ errors.userAuditors | join }}
            </p>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-multi-select
              [(selectedItems)]="project.userGroupAuditors"
              (selectedItemsChange)="updateMembers()"
              [options]="userGroups"
              [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-multi-select>
            <p
              *ngIf="errors?.userGroupAuditors"
              class="p-error">
              {{ errors.userGroupAuditors | join }}
            </p>
          </div>
        </div>
      </p-card>

      <p-card
        header="Заявка HD"
        styleClass="mt-3">
        <div class="field">
          <label class="font-medium">Заявка HelpDesk</label>
          <crm-hd-task-multi-select
            [tasks]="tasks"
            [(selectedTasks)]="project.helpdeskTasks"
            [isError]="$any(errors?.helpdeskTasks)"
            appendTo="body"></crm-hd-task-multi-select>
          <p
            *ngIf="errors?.helpdeskTasks"
            class="p-error">
            {{ errors.helpdeskTasks | join }}
          </p>
        </div>
      </p-card>

      <p-card
        header="Сделка"
        styleClass="mt-3">
        <div class="field">
          <label class="font-medium">Сделка</label>
          <crm-deal-multi-select
            [(selectedDeals)]="project.deals"
            [isError]="$any(errors?.deals)"
            appendTo="body"></crm-deal-multi-select>
          <p
            *ngIf="errors?.deals"
            class="p-error">
            {{ errors.deals | join }}
          </p>
        </div>
      </p-card>

      <div
        *ngIf="!(form$ | async)?.isShowDelete"
        class="mt-3">
        <p class="text-xl font-medium ml-3">События</p>
        <p-divider></p-divider>
        <ng-container *ngFor="let checklist of project.checklists; let index = index">
          <p-card styleClass="mb-3 p-3 very-compact-card">
            <div class="p-fluid">
              <div class="field">
                <label class="font-medium required-field">Событие</label>
                <crm-input-text
                  [(value)]="checklist.name"
                  [isError]="$any(errors?.checklists?.[index]?.['name'])"></crm-input-text>
                <small
                  *ngIf="errors?.checklists?.[index]?.['name']"
                  class="p-error">
                  {{ errors.checklists[index]['name'] | join }}
                </small>
              </div>

              <div class="grid">
                <div class="col">
                  <div class="field">
                    <label class="font-medium required-field">Тип</label>
                    <crm-single-select
                      [options]="checklistTypes"
                      [(selectedItem)]="checklist.type"
                      [filter]="false"
                      [styleClass]="errors?.checklists?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                      [class]="errors?.checklists?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                      appendTo="body"></crm-single-select>
                    <small
                      *ngIf="errors?.checklists?.[index]?.['type']"
                      class="p-error">
                      {{ errors.checklists[index]['type'] | join }}
                    </small>
                  </div>
                </div>
                <div class="col">
                  <div class="field">
                    <label class="font-medium">Эпик</label>
                    <crm-master-milestone-single-select
                      [masterMilestones]="masterMilestones"
                      [(selectedMasterMilestone)]="checklist.masterMilestone"
                      [isError]="$any(errors?.checklists?.[index]?.['masterMilestone'])"
                      [customRequest]="true"
                      appendTo="body"></crm-master-milestone-single-select>
                    <small
                      *ngIf="errors?.checklists?.[index]?.['masterMilestone']"
                      class="p-error">
                      {{ errors.checklists[index]['masterMilestone'] | join }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="font-medium required-field">Участники</label>
                <crm-user-multi-select
                  [users]="participants"
                  [(selectedUsers)]="checklist.responsible"
                  [isError]="$any(errors?.checklists?.[index]?.['responsible'])"
                  [customRequest]="true"
                  [isFloatLabel]="false"
                  appendTo="body"></crm-user-multi-select>
                <small
                  *ngIf="errors?.checklists?.[index]?.['responsible']"
                  class="p-error">
                  {{ errors.checklists[index]['responsible'] | join }}
                </small>
              </div>

              <crm-checklist-period-form
                [(startAt)]="checklist.startAt"
                [(endAt)]="checklist.endAt"
                [minDateEnd]="checklist.startAt | dateAdd: 15:'minutes'"
                [errors]="errors?.checklists?.[index]"
                [canDelete]="(form$ | async)?.isShowDelete"
                appendTo="body"></crm-checklist-period-form>

              <div class="field">
                <label class="font-medium">Описание</label>
                <crm-editor [(value)]="checklist.description"></crm-editor>
                <small
                  *ngIf="errors?.checklists?.[index]?.['description']"
                  class="p-error">
                  {{ errors.checklists[index]['description'] | join }}
                </small>
              </div>
            </div>

            <div class="flex justify-content-end">
              <button
                pButton
                type="button"
                icon="pi pi-trash"
                label="Удалить"
                class="p-button-danger p-button-text"
                (click)="deleteChecklist(checklist)"></button>
            </div>
          </p-card>
        </ng-container>

        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Добавить событие"
          class="p-button-success p-button-text"
          (click)="addChecklist()"></button>
      </div>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveProject()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteProject()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
